import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { DealerFullModel } from '../../../../shared/dealer';
import { useTranslation } from '../../../translations';

export const DealerButtons: FC<{
  readonly dealer: DealerFullModel;
  readonly dealerAssistantLimit: number;
}> = ({ dealer, dealerAssistantLimit }) => {
  const { ts } = useTranslation();
  return (
    <div className="mb-10">
      <Link to="/vendor/edit">
        <Button color="primary" id="editDealer" style={{ marginRight: '10px' }}>
          {ts('edit_dealer')}
        </Button>
      </Link>
      {dealer.applications.some((t) => t.status === 'approved') && (
        <>
          <Link to="/vendor/seating">
            <Button color="secondary" id="seatingPreferences" style={{ marginRight: '10px' }}>
              {ts('seating_preferences')}
            </Button>
          </Link>
          {dealerAssistantLimit > 0 && (
            <Link to="/vendor/assistants">
              <Button color="secondary" id="manageAssistants">
                {ts('manage_assistants')}
              </Button>
            </Link>
          )}
        </>
      )}
    </div>
  );
};
